module.exports = "<!-- Wrapper -->\n\n<app-header [hidden]=\"! auth.isAuthenticated\"></app-header>\n\n<div class=\"page-wrapper\">\n\n    <div class=\"container\">\n\n        <router-outlet></router-outlet>\n\n    </div>\n\n</div><!-- /.wrapper -->\n\n<!-- /Wrapper -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main